import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  AddPackageToVideoFailAction,
  AddPackageToVideoRequestAction,
  AddPackageToVideoSuccessAction,
  CreateVideoDetailFailAction,
  CreateVideoDetailRequestAction,
  CreateVideoDetailSuccessAction,
  DeleteVideoDetailFailAction,
  DeleteVideoDetailRequestAction,
  DeleteVideoDetailSuccessAction,
  FetchPackageByRefIdFailAction,
  FetchPackageByRefIdRequestAction,
  FetchPackageByRefIdSuccessAction,
  FetchVideoDetailsFailureAction,
  FetchVideoDetailsRequestAction,
  FetchVideoDetailsSuccessAction,
  FetchVideoViewCountFailureAction,
  FetchVideoViewCountRequestAction,
  FetchVideoViewCountSuccessAction,
  ResetVideo,
  SetVideoToAnotherGroupFailAction,
  SetVideoToAnotherGroupRequestAction,
  SetVideoToAnotherGroupSuccessAction,
  stateStatusType,
  UpdateVideoDetailFailAction,
  UpdateVideoDetailRequestAction,
  UpdateVideoDetailSuccessAction,
  UpdateVideoFeaturedFailAction,
  UpdateVideoFeaturedRequestAction,
  UpdateVideoFeaturedSuccessAction,
  UpdateVideoVisibilityFailAction,
  UpdateVideoVisibilityRequestAction,
  UpdateVideoVisibilitySuccessAction,
  UploadVideoFailAction,
  UploadVideoRequestAction,
  UploadVideoSuccessAction,
  VideoDetailActions,
} from "./actionType";
import { initialState, VideoDetailsState } from "./state";

//FetchVideoEpisodeRequest
const FetchVideoDetailRequest = (
  state: VideoDetailsState,
  action: FetchVideoDetailsRequestAction
) => {
  return updateObject(state, {
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchVideoDetailSuccess = (
  state: VideoDetailsState,
  action: FetchVideoDetailsSuccessAction
) => {
  return updateObject(state, {
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_details: action.payload,
    },
  });
};

const FetchVideoDetailFail = (
  state: VideoDetailsState,
  action: FetchVideoDetailsFailureAction
) => {
  return updateObject(state, {
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      video_details: null,
    },
  });
};

//FetchVideovide count
const FetchVideoViewCountRequest = (
  state: VideoDetailsState,
  action: FetchVideoViewCountRequestAction
) => {
  return updateObject(state, {
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchVideoViewCountSuccess = (
  state: VideoDetailsState,
  action: FetchVideoViewCountSuccessAction
) => {
  return updateObject(state, {
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      viewCount: action.payload,
    },
  });
};

const FetchVideoViewCountFail = (
  state: VideoDetailsState,
  action: FetchVideoViewCountFailureAction
) => {
  return updateObject(state, {
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      video_details: null,
    },
  });
};

//create video
const CreateVideoDetailRequest = (
  state: VideoDetailsState,
  action: CreateVideoDetailRequestAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: true,
      error: null,
    },
  });
}
const CreateVideoDetailSuccess = (
  state: VideoDetailsState,
  action: CreateVideoDetailSuccessAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      video_details: action.payload,
    },
  });
};
const CreateVideoDetailFail = (
  state: VideoDetailsState,
  action: CreateVideoDetailFailAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error:null,
      status: stateStatusType.FAILED,
    },
  });
};

//update video
const UpdateVideoDetailRequest = (
  state: VideoDetailsState,
  action: UpdateVideoDetailRequestAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: true,
      error: null,
    },
  });
}
const UpdateVideoDetailSuccess = (
  state: VideoDetailsState,
  action: UpdateVideoDetailSuccessAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_details: action.payload,
    },
  });
};
const UpdateVideoDetailFail = (
  state: VideoDetailsState,
  action: UpdateVideoDetailFailAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error:null,
      status: stateStatusType.FAILED,
    },
  });
};

//delete series
const DeleteVideoDetailRequest = (
  state: VideoDetailsState,
  action: DeleteVideoDetailRequestAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: true,
      error: null,
    },
  });
}
const DeleteVideoDetailSuccess = (
  state: VideoDetailsState,
  action: DeleteVideoDetailSuccessAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      delete: action.payload,
      status: stateStatusType.SUCCESS,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      delete: null,
      status: stateStatusType.SUCCESS,
    },
  });
};
const DeleteVideoDetailFail = (
  state: VideoDetailsState,
  action: DeleteVideoDetailFailAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};

//reset video
const resetVideo = (state: VideoDetailsState, action: ResetVideo) => ({
  ...state,
  genericVideoDetailsState: { ...initialState.genericVideoDetailsState },
  addPackageToVideoState: { ...initialState.addPackageToVideoState },
});

//Upload video
const UploadVideoRequest = (
  state: VideoDetailsState,
  action: UploadVideoRequestAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: true,
      error: null,
    },
  });
}
const UploadVideoSuccess = (
  state: VideoDetailsState,
  action: UploadVideoSuccessAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      upload_Video: action.payload,
    },
  });
};
const UploadVideoFail = (
  state: VideoDetailsState,
  action: UploadVideoFailAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error:null,
      status: stateStatusType.FAILED,
    },
  });
};

//update video visibility
const UpdateVideoVisibilityRequest = (
  state: VideoDetailsState,
  action: UpdateVideoVisibilityRequestAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: true,
      error: null,
    },
  });
}
const UpdateVideoVisibilitySuccess = (
  state: VideoDetailsState,
  action: UpdateVideoVisibilitySuccessAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_details: action.payload,
    },
  });
};
const UpdateVideoVisibilityFail = (
  state: VideoDetailsState,
  action: UpdateVideoVisibilityFailAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error:null,
      status: stateStatusType.FAILED,
    },
  });
};
//update video featured
const UpdateVideoFeaturedRequest = (
  state: VideoDetailsState,
  action: UpdateVideoFeaturedRequestAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: true,
      error: null,
    },
  });
}
const UpdateVideoFeaturedSuccess = (
  state: VideoDetailsState,
  action: UpdateVideoFeaturedSuccessAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_details: action.payload,
    },
  });
};
const UpdateVideoFeaturedFail = (
  state: VideoDetailsState,
  action: UpdateVideoFeaturedFailAction
) => {
  return updateObject(state, {
    genericVideoDetailsState: {
      ...state.genericVideoDetailsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoDetailsState: {
      ...state.videoDetailsState,
      isLoading: false,
      error:null,
      status: stateStatusType.FAILED,
    },
  });
};
//fetch package by ref id
const fetchPackageByRefIdRequest = (
  state: VideoDetailsState,
  action: FetchPackageByRefIdRequestAction
) => {
  return updateObject(state, {
    addPackageToVideoState: {
      ...state.addPackageToVideoState,
      isLoading: true,
      error: null,
    },
  });
}
const fetchPackageByRefIdSuccess = (
  state: VideoDetailsState,
  action: FetchPackageByRefIdSuccessAction
) => {
  return updateObject(state, {
    addPackageToVideoState: {
      ...state.addPackageToVideoState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      videoPackage:action.payload,
    },
  });
};
const fetchPackageByRefIdFail = (
  state: VideoDetailsState,
  action: FetchPackageByRefIdFailAction
) => {
  return updateObject(state, {
    addPackageToVideoState: {
      ...state.addPackageToVideoState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//add package to video 
const addPackageToVideoRequest = (
  state: VideoDetailsState,
  action: AddPackageToVideoRequestAction
) => {
  return updateObject(state, {
    addPackageToVideoState: {
      ...state.addPackageToVideoState,
      isLoading: true,
      error: null,
    },
  });
}
const addPackageToVideoSuccess = (
  state: VideoDetailsState,
  action: AddPackageToVideoSuccessAction
) => {
 const existingPackages =
    state.addPackageToVideoState.videoPackage || [];
    const incomingPackages = action.payload;
 const packageMap = new Map();

  existingPackages.forEach(pkg => {
    packageMap.set(pkg.id, pkg);
  });

  incomingPackages.forEach(pkg => {
    packageMap.set(pkg.id, pkg);
  });

  const mergedPackages = Array.from(packageMap.values());
  return updateObject(state, {
    addPackageToVideoState: {
      ...state.addPackageToVideoState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      videoPackage: mergedPackages
    },
  });
};
const addPackageToVideoFail = (
  state: VideoDetailsState,
  action: AddPackageToVideoFailAction
) => {
  return updateObject(state, {
    addPackageToVideoState: {
      ...state.addPackageToVideoState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};


const setVideoToAnotherGroupRequest = (
  state: VideoDetailsState,
  action: SetVideoToAnotherGroupRequestAction
) => {
  return updateObject(state, {
    setVideoToAnotherGroupState: {
      ...state.setVideoToAnotherGroupState,
      isLoading: true,
      error: null,
    },
  });
}
const setVideoToAnotherGroupSuccess = (
  state: VideoDetailsState,
  action: SetVideoToAnotherGroupSuccessAction
) => {
  return updateObject(state, {
    setVideoToAnotherGroupState: {
      ...state.setVideoToAnotherGroupState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
  });
}
const setVideoToAnotherGroupFail = (
  state: VideoDetailsState,
  action: SetVideoToAnotherGroupFailAction
) => {
  return updateObject(state, {
    setVideoToAnotherGroupState: {
      ...state.setVideoToAnotherGroupState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
}

const VideoDetailsReducer = (
  state = initialState,
  action: VideoDetailActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_VIDEO_DETAIL_REQUEST:
      return FetchVideoDetailRequest(state, action);
    case actionTypes.FETCH_VIDEO_DETAIL_SUCCESS:
      return FetchVideoDetailSuccess(state, action);
    case actionTypes.FETCH_VIDEO_DETAIL_FAIL:
      return FetchVideoDetailFail(state, action);
    case actionTypes.FETCH_VIDEO_VIEW_COUNT_REQUEST:
      return FetchVideoViewCountRequest(state, action);
    case actionTypes.FETCH_VIDEO_VIEW_COUNT_SUCCESS:
      return FetchVideoViewCountSuccess(state, action);
    case actionTypes.FETCH_VIDEO_VIEW_COUNT_FAIL:
      return FetchVideoViewCountFail(state, action);
    case actionTypes.CREATE_VIDEO_DETAIL_REQUEST:
      return CreateVideoDetailRequest(state, action);
    case actionTypes.CREATE_VIDEO_DETAIL_SUCCESS:
      return CreateVideoDetailSuccess(state, action);
    case actionTypes.CREATE_VIDEO_DETAIL_FAIL:
      return CreateVideoDetailFail(state, action);
    case actionTypes.UPDATE_VIDEO_DETAIL_REQUEST:
      return UpdateVideoDetailRequest(state, action);
    case actionTypes.UPDATE_VIDEO_DETAIL_SUCCESS:
      return UpdateVideoDetailSuccess(state, action);
    case actionTypes.UPDATE_VIDEO_DETAIL_FAIL:
      return UpdateVideoDetailFail(state, action);
    case actionTypes.DELETE_VIDEO_DETAIL_REQUEST:
      return DeleteVideoDetailRequest(state, action);
    case actionTypes.DELETE_VIDEO_DETAIL_SUCCESS:
      return DeleteVideoDetailSuccess(state, action);
    case actionTypes.DELETE_VIDEO_DETAIL_FAIL:
      return DeleteVideoDetailFail(state, action);
    case actionTypes.UPLOAD_VIDEO_REQUEST:
      return UploadVideoRequest(state, action);
    case actionTypes.UPLOAD_VIDEO_SUCCESS:
      return UploadVideoSuccess(state, action);
    case actionTypes.UPLOAD_VIDEO_FAIL:
      return UploadVideoFail(state, action);
    case actionTypes.UPDATE_VIDEO_VISIBILITY_REQUEST:
      return UpdateVideoVisibilityRequest(state, action);
    case actionTypes.UPDATE_VIDEO_VISIBILITY_SUCCESS:
      return UpdateVideoVisibilitySuccess(state, action);
    case actionTypes.UPDATE_VIDEO_VISIBILITY_FAIL:
      return UpdateVideoVisibilityFail(state, action);
    case actionTypes.UPDATE_VIDEO_FEATURED_REQUEST:
      return UpdateVideoFeaturedRequest(state, action);
    case actionTypes.UPDATE_VIDEO_FEATURED_SUCCESS:
      return UpdateVideoFeaturedSuccess(state, action);
    case actionTypes.UPDATE_VIDEO_FEATURED_FAIL:
      return UpdateVideoFeaturedFail(state, action);
    case actionTypes.FETCH_PACKAGE_BY_REF_ID_REQUEST:
      return fetchPackageByRefIdRequest(state, action);
    case actionTypes.FETCH_PACKAGE_BY_REF_ID_SUCCESS:
      return fetchPackageByRefIdSuccess(state, action);
    case actionTypes.FETCH_PACKAGE_BY_REF_ID_FAIL:
      return fetchPackageByRefIdFail(state, action);
    case actionTypes.ADD_PACKAGE_TO_VIDEO_REQUEST:
      return addPackageToVideoRequest(state, action);
    case actionTypes.ADD_PACKAGE_TO_VIDEO_SUCCESS:
      return addPackageToVideoSuccess(state, action);
    case actionTypes.ADD_PACKAGE_TO_VIDEO_FAIL:
      return addPackageToVideoFail(state, action);
    case actionTypes.RESET_VIDEO:
            return resetVideo(state, action);
    case actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_REQUEST:
      return setVideoToAnotherGroupRequest(state, action);
    case actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_SUCCESS:
      return setVideoToAnotherGroupSuccess(state, action);
    case actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_FAIL:
      return setVideoToAnotherGroupFail(state, action);
    default:
      return state;
  }
};
export default VideoDetailsReducer;
